import { CompCardItemCore } from '../core/card/item.comp'

export const CompCardItem = CompCardItemCore
